import { isProd } from 'sdk/sso/config/env'

const logger = window?.Rollbar?.info
  ? (...args: unknown[]) => window.Rollbar.info(...args)
  : (...args: any[]) => {
      if (!isProd()) {
        // tslint:disable-next-line: no-console
        console.log(...args)
      }
    }
export default logger
